import React, { ReactElement } from 'react';
import EFormRegister from '../../components/EFormRegister';

export const EFormRegisterPage = (): ReactElement => {
  return <EFormRegister />;
};

export default EFormRegisterPage;
